import myProfileTab, { en as myProfileEN, ca as myProfileCA } from './myProfileTab'
import school, { en as schoolEN, ca as schoolCA } from './schoolTab'
import educationalLevel, { en as educationalLevelEN, ca as educationalLevelCA } from './educationalLevel'
import teamAdmin, { en as teamAdminEN, ca as teamAdminCA } from './teamAdmin'
import discardChangesModal, { en as discardChangesModalEN, ca as discardChangesModalCA } from './discardChangesModal'

export default {
  edit: {
    myProfile: 'Editar perfil',
    school: 'Editar escuela',
    schoolGroup: 'Editar red de escuelas'
  },
  save: 'Guardar',
  cancel: 'Cancelar',
  personalInfo: 'Nombre y apellido',
  appointment: 'Cargo',
  deletePhoto: 'Eliminar Foto',
  changePhoto: 'Cambiar Foto',
  position: {
    principal: 'Dirección General',
    vicePrincipal: 'Subdirección',
    levelCoordinator: 'Coordinación de nivel',
    areaCoordinator: 'Coordinación de departamento',
    innovationCoordinator: 'Coordinación de innovación',
    academicOrPedagogicalCoordinator: 'Coordinación académica/pedagógica',
    teacherEducation: 'Formación docente',
    teacher: 'Docente',
    iCT: 'TIC',
    pastoral: 'Pastoral',
    management: 'Administración'
  },
  tabs: {
    myProfile: 'Mi perfil',
    school: 'Escuela',
    schoolGroup: 'Red de escuelas'
  },
  myProfileTab,
  schoolTab: school,
  educationalLevel,
  teamAdmin,
  modal: discardChangesModal,
  close: 'Cerrar',
  changeAvatar: 'Cambiar foto',
  deleteAvatar: 'Eliminar foto'
}

export const en = {
  edit: {
    myProfile: 'Edit profile',
    school: 'Edit school',
    schoolsNetwork: 'Edit schools network'
  },
  save: 'Save',
  cancel: 'Cancel',
  personalInfo: 'Name and last name',
  appointment: 'Position',
  deletePhoto: 'Delete photo',
  changePhoto: 'Change photo',
  position: {
    principal: 'General Management',
    vicePrincipal: 'Deputy Management',
    levelCoordinator: 'Level Coordination',
    areaCoordinator: 'Department Coordination',
    innovationCoordinator: 'Innovation Coordination',
    academicOrPedagogicalCoordinator: 'Academic/Pedagogical Coordination',
    teacherEducation: 'Teacher training',
    teacher: 'Teacher',
    iCT: 'ICT',
    pastoral: 'Pastoral',
    management: 'Administration'
  },
  tabs: {
    myProfile: 'My profile',
    school: 'School',
    schoolsNetwork: 'Schools network'
  },
  myProfileTab: myProfileEN,
  schoolTab: schoolEN,
  educationalLevel: educationalLevelEN,
  teamAdmin: teamAdminEN,
  modal: discardChangesModalEN,
  close: 'Close',
  changeAvatar: 'Change photo',
  deleteAvatar: 'Delete photo'
}

export const ca = {
  edit: {
    myProfile: 'Edita el perfil',
    school: 'Edita l\'escola',
    schoolsNetwork: 'Edita la xarxa d\'escoles'
  },
  save: 'Desa',
  cancel: 'Cancel·la',
  personalInfo: 'Nom i cognoms',
  appointment: 'Càrrec',
  deletePhoto: 'Elimina la Foto',
  changePhoto: 'Canvia la Foto',
  position: {
    principal: 'Direcció General',
    vicePrincipal: 'Subdirecció',
    levelCoordinator: 'Coordinació de nivell',
    areaCoordinator: 'Coordinació de departament',
    innovationCoordinator: 'Coordinació  d\'innovació',
    academicOrPedagogicalCoordinator: 'Coordinació acadèmica/pedagògica',
    teacherEducation: 'Plantel docente',
    teacher: 'Docent',
    iCT: 'TIC',
    pastoral: 'pedir a Belu',
    management: 'Administración'
  },
  tabs: {
    myProfile: 'El meu perfil',
    school: 'Escola',
    schoolsNetwork: 'Xarxa d\'escoles'
  },
  myProfileTab: myProfileCA,
  schoolTab: schoolCA,
  educationalLevel: educationalLevelCA,
  teamAdmin: teamAdminCA,
  modal: discardChangesModalCA,
  close: 'Tanca',
  changeAvatar: 'Canvia la foto',
  deleteAvatar: 'Elimina la foto'
}
